import type { IRouteConfig } from "../interfaces/IRouteConfig";
import { PebbleAmdRoute } from "./pebbleAmdRoute";

export class PebbleAmdRouteFactory {
    public static create<T>(routeConfig: IRouteConfig<T>): IRouteConfig<T> {
        const newRouteConfig = Object.assign({}, routeConfig);
        const route = new PebbleAmdRoute(newRouteConfig);
        
        if (newRouteConfig.resolve === undefined) {
            newRouteConfig.resolve = {};
        }

        newRouteConfig.resolve.___APebbleRouteResolve = route.resolve;
        return newRouteConfig;
    }
}
